import PropTypes from "prop-types";
import { SDP_HERO_TEXT_ALIGN } from "app/constants";
import "./SmartDPMarketingHeadline.scss";
import { memo } from "react";
import { messagePropType } from "app/utils/propTypes";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import CustomFormattedMessageContainer from "app/utils/CustomFormattedMessageContainer";

const SmartDPMarketingHeadline = ({ title, subtitle, textAlign, lowestPrice }) => {
	let align = "center";
	if (textAlign === SDP_HERO_TEXT_ALIGN.LEFT) {
		align = "flex-start";
	} else if (textAlign === SDP_HERO_TEXT_ALIGN.RIGHT) {
		align = "flex-end";
	}

	return (
		<h1
			className="smartdp-marketing-headline"
			style={{
				alignItems: align,
			}}
		>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL4}
				variantSM={TYPOGRAPHY_VARIANTS.XL6}
				variantMD={TYPOGRAPHY_VARIANTS.XL8}
				variantLG={TYPOGRAPHY_VARIANTS.XL9}
				isBold
				className="smartdp-marketing-headline__title"
				component="div"
			>
				<CustomFormattedMessageContainer
					message={title}
					lowestPrice={lowestPrice}
					enableHTMLFormatting={true}
				/>
			</Typography>{" "}
			{/* keep this space for H1 title and subtitle being separated*/}
			<Typography
				variant={TYPOGRAPHY_VARIANTS.REGULAR}
				variantMD={TYPOGRAPHY_VARIANTS.XL3}
				isBold
				className="smartdp-marketing-headline__subtitle"
				component="div"
			>
				<CustomFormattedMessageContainer
					message={subtitle}
					lowestPrice={lowestPrice}
					enableHTMLFormatting={true}
				/>
			</Typography>
		</h1>
	);
};

SmartDPMarketingHeadline.propTypes = {
	title: messagePropType,
	subtitle: messagePropType,
	lowestPrice: PropTypes.number,
	textAlign: PropTypes.string,
};

export default memo(SmartDPMarketingHeadline);
